// The conversation list's helpers, shared by the /chat page (its history menu,
// and the phone's History sheet) and the floating assistant's history popup.

// Show the history search box once the conversation list reaches this size
// (mirrors Linear's floating assistant).
export const SEARCH_THRESHOLD = 4;

// Bucket sessions into recency groups (Today / Yesterday / Previous 7 days /
// Older) for the history menu, like ChatGPT. Returns only non-empty groups,
// in display order; `key` maps to an i18n label under `history.*`.
export const groupSessions = (sessions) => {
  const now = new Date();
  const startOfToday = new Date(now.getFullYear(), now.getMonth(), now.getDate());
  const startOfYesterday = new Date(startOfToday);
  startOfYesterday.setDate(startOfToday.getDate() - 1);
  const start7 = new Date(startOfToday);
  start7.setDate(startOfToday.getDate() - 7);

  const buckets = { today: [], yesterday: [], previous7: [], older: [] };
  sessions.forEach((s) => {
    const d = new Date(s.updated_at);
    if (d >= startOfToday) buckets.today.push(s);
    else if (d >= startOfYesterday) buckets.yesterday.push(s);
    else if (d >= start7) buckets.previous7.push(s);
    else buckets.older.push(s);
  });

  return ['today', 'yesterday', 'previous7', 'older']
    .map((key) => ({ key, items: buckets[key] }))
    .filter((g) => g.items.length > 0);
};

// Sessions whose title contains the search text (case-insensitive), newest
// first.
export const filterSessions = (sessions, search) => {
  const q = search.trim().toLowerCase();
  const list = q
    ? sessions.filter((s) => (s.title || '').toLowerCase().includes(q))
    : sessions;
  return [...list].sort((a, b) => new Date(b.updated_at || 0) - new Date(a.updated_at || 0));
};
